/**
 * Gets an array of adjusted weekdays names for a given start day.
 *
 * @param {array} names Array of weekday names, the first value being Sunday.
 * @param {number} start The first day of the week, 0 being Sunday.
 */
export function getDayNames(names, start = 0) {
	return [
		...names.slice(start),
		...names.slice(0, start),
	];
}
